module.exports = __webpack_public_path__ + "static/media/puzzle-stars.7f68dffd.mp4";